import { useRef, useLayoutEffect, useState } from "react";
import { Button } from "@douyinfe/semi-ui";
import enhancedImg from "@assets/light_icons/enchanced_img.png";
import unprecedentedImg from "@assets/light_icons/unprecedented_img.png";
import lightningImg from "@assets/light_icons/lightning_img.png";
import { ReactComponent as CheckIcon } from "@assets/icons/check_icon.svg";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";
import classNames from "classnames";

const Promotion = () => {
  const { t, i18n } = useTranslation();
  const divRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useLayoutEffect(() => {
    let resizeObserver: ResizeObserver | undefined = undefined;
    if (divRef.current) {
      resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const { height } = entry.contentRect;
          setContentHeight(height);
        }
      });

      resizeObserver.observe(divRef.current);
    }

    return () => {
      if (resizeObserver && divRef.current) {
        resizeObserver.unobserve(divRef.current);
      }
    };
  }, []);
  return (
    <div
      className={classNames({
        [styles.pageContainer]: true,
        [styles.center]: contentHeight > 788,
        [styles.cn]: i18n.resolvedLanguage === "zh",
      })}
      ref={divRef}
    >
      <div className={styles.headerContainer}>
        <div className={`${styles.title} appear-animate`}>
          {t("promotionPage.title")}
        </div>
        <div className={styles.btnContainer}>
          <a href="mailto:ai@biogeom.com">
            <Button theme="solid" type="primary" className="appear-animate">
              {t("promotionPage.buttonText")}
            </Button>
          </a>
        </div>
      </div>
      <div className={styles.content}>
        <div className={`${styles.panelContainer} appear-animate`}>
          <div className={styles.panel}>
            <div className={styles.header}>
              <img src={enhancedImg} className={styles.img} />
              <div
                className={styles.title}
                dangerouslySetInnerHTML={{
                  __html: t("promotionPage.content.specificity.title"),
                }}
              ></div>
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{
                  __html: t("promotionPage.content.specificity.description"),
                }}
              ></div>
            </div>
            <div className={styles.footer}>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.specificity.feature1")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.specificity.feature2")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.specificity.feature3")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.panel}>
            <div className={styles.header}>
              <img src={unprecedentedImg} className={styles.img} />
              <div
                className={styles.title}
                dangerouslySetInnerHTML={{
                  __html: t("promotionPage.content.versatility.title"),
                }}
              ></div>
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{
                  __html: t("promotionPage.content.versatility.description"),
                }}
              ></div>
            </div>
            <div className={styles.footer}>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.versatility.feature1")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.versatility.feature2")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.versatility.feature3")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.panel}>
            <div className={styles.header}>
              <img src={lightningImg} className={styles.img} />
              <div
                className={styles.title}
                dangerouslySetInnerHTML={{
                  __html: t("promotionPage.content.innovation.title"),
                }}
              ></div>
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{
                  __html: t("promotionPage.content.innovation.description"),
                }}
              ></div>
            </div>
            <div className={styles.footer}>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.innovation.feature1")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.innovation.feature2")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.desc}>
                  {t("promotionPage.content.innovation.feature3")}
                </div>
                <div className={styles.icon}>
                  <CheckIcon />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promotion;
